import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import {
  PageHeader,
  PageTitleContainer,
  PageTitle,
  PageIcon,
  InfoIconContainer,
  PageDescription,
  useGoBack,
  Button
} from '../../styles/PageStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusSquare } from '@fortawesome/free-regular-svg-icons';
import { faChalkboardTeacher, faChartColumn, faChartDiagram, faDiagramPredecessor, faGauge, faHurricane, faKeyboard, faLandmark, faLayerGroup, faNetworkWired, faPlusSquare, faScrewdriverWrench, faSlidersH, faStaffSnake, faUsersRectangle, faVault, faWindowRestore, faSun, faWalkieTalkie, faFileShield, faCodeCompare, faChartGantt, faGears, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';

const PageHeaderWithInfo = ({ icon, title, description, children,goBack }) => {
  const [showDescription, setShowDescription] = useState(false);

  const goBackBtn = useGoBack();
  return (
    <>
      <PageHeader>
        <PageTitleContainer>
          <PageTitle>
            {goBack === true && (
              <Button onClick={goBackBtn} secondary ><FontAwesomeIcon icon={faChevronCircleLeft} /></Button>
            )}
            {!goBack  && (
            <PageIcon>{typeof icon === 'string' ? icon : <FontAwesomeIcon icon={icon} />}</PageIcon> 
            )}
            {title}
          </PageTitle>
          {description && (
          <InfoIconContainer onClick={() => setShowDescription(!showDescription)}>
            i
          </InfoIconContainer>
          )}
        </PageTitleContainer>
        <div style={{ flex: 1 }} />
        <div style={{ display: "flex", alignItems: "center" }}>
        {children}
        </div>
      </PageHeader>
      <AnimatePresence>
        {showDescription && (
          <PageDescription
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1, minHeight:'40px' }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {description}
          </PageDescription>
        )}
      </AnimatePresence>
    </>
  );
};

export default PageHeaderWithInfo;
